import { Box, Divider, Typography } from '@mui/material';
import { MaxSummaryList } from './MaxSummaryList';

export const AdminMaxSummaries = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%',
                height: '100%',
            }}>
            <Box>
                <Typography variant="h5" sx={{ p: 3, pb: 0 }}>
                    Max Security Summaries
                </Typography>
                <Divider sx={{ mt: 2 }} />
            </Box>
            <MaxSummaryList />
        </Box>
    );
};
